import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addUser, setCoachFormValue, getUserById, editUser } from '../../admin.actions'
import Button from '../../../../components/button/button'
import './add.css';
import Modal from '../../../../components/modal/modal';
import { Icon } from 'antd'


class AddAdmin extends Component {

  constructor(props) {
    super(props)
    this.state = { isEdit: false, showPassword: false }
  }

  componentDidMount() {
    const { match, getUserById } = this.props;
    if (match.params.id) {
      getUserById(this.props.match.params.id)
      this.setState({ isEdit: true })
    }
  }

  formIsValid() {
    const { email = '', password = '', username = '', name = '' } = this.props.admin.formAdd
    const regexEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    let formIsValid = true

    if (!email || !regexEmail.test(email)) {
      formIsValid = false
    } else if (!this.state.isEdit && (!password || password.length < 6)) {
      formIsValid = false
    } else if (!username) {
      formIsValid = false
    } else if (!name) {
      formIsValid = false
    }
    return formIsValid
  }

  changeShowPassword() {
    this.props.setCoachFormValue({ target: { id: 'password', value: '' } })
    this.setState({ showPassword: !this.state.showPassword })
  }

  render() {
    const { inRequest, formAdd, loadingUser } = this.props.admin;
    const { email = '', password = '', username = '', name = '' } = formAdd
    const { addUser, editUser, isOpen, onClose } = this.props
    const { isEdit, showPassword } = this.state
    return loadingUser ? <Icon type='sync' spin={loadingUser} className="list-users-icon icon-value" /> :
      (
      <Modal isOpen={isOpen} onClose={onClose} title={`${isEdit ? 'Editar usuário' : 'Cadastrar novo usuário'}`}>
        <section className="add-coach-component">
          <form className='form'>
            <div className='input-content'>
              <input onChange={this.props.setCoachFormValue} value={name} id='name' placeholder="Nome" />
            </div>
            <div className='input-content'>
              <input onChange={this.props.setCoachFormValue} value={email} id='email' type="email" placeholder="E-mail" />
            </div>
            <div className='input-content'>
              <input onChange={this.props.setCoachFormValue} value={username} id='username' placeholder="Login" />
            </div>
            {isEdit && <span className="show-password" onClick={() => this.changeShowPassword()}> {showPassword ? 'Não definir nova senha' : 'Definir nova senha'}</span>}
            {
              (!isEdit || showPassword)
              && <div className='input-content'>
                <input onChange={this.props.setCoachFormValue} value={password} id='password' type="password" placeholder={`${isEdit ? 'Nova Senha' : 'Senha'}`} />
              </div>
            }
            <Button
              onClick={() => { isEdit ? editUser({ ...formAdd }) : addUser({ ...formAdd }) }}
              disabled={inRequest || !this.formIsValid()}
              text={inRequest ? 'Carregando' : `${isEdit ? 'Editar' : 'Cadastrar'}`}
              iconName='loading' showIcon={inRequest}
              className='save-button' />
          </form>
        </section>
      </Modal>
      )
  }
}

const mapStateToProps = state => ({
  admin: state.admin
})

const mapDispatchToProps = dispatch => bindActionCreators({ addUser, setCoachFormValue, getUserById, editUser }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AddAdmin)



// WEBPACK FOOTER //
// ./src/App/containers/admin/sections/add/add.js